<mat-card class="titleBar filter">
    <div class="all">
        <button mat-flat-button [matMenuTriggerFor]="notification" class="user-button">
           All <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
          <mat-menu class="customPanel" #notification="matMenu">
            <mat-card class="filterOption">
                <div class="fillist">
                    <label>Facility Name</label>
                    <div class="filterlist">                
                      <ng-container >                 
                        <div class="lList"><span class="name" >Green Care</span> </div>   
                        <div class="lList"><span class="name" >Home Care</span> </div>       
                      </ng-container>
                    </div>
                </div>
                <div class="fillist">
                    <label>Saved Filter</label>
                    <div class="filterlist">                
                      <ng-container >                 
                        <div class="lList"><span class="name" >Filter 1</span> </div>   
                        <div class="lList"><span class="name" >Filter 2</span> </div>       
                      </ng-container>
                    </div>
                </div>
            </mat-card>
          </mat-menu>
    </div>
    <div class="quickfilter">

          <mat-form-field class="searchField" appearance="">
            <mat-label>Search by Name, Tag & Equipmentt</mat-label>
            <input matInput type="text">
            <!-- <button  mat-icon-button>
              <mat-icon>close</mat-icon>
            </button> -->
          </mat-form-field>
          <button mat-icon-button (click)="openFilter()" ><mat-icon>filter_list</mat-icon></button>
    </div>
</mat-card>

<div class="calendarHolder">
    <img src="../../../../assets/images/doctor_calendar.png" alt="" >
</div>

<app-filter [ngClass]="{'open': showFilter}" (closeFilter)=getCloseFilter($event)  ></app-filter>